import { IconCopy, IconDownload, IconFileText } from "@tabler/icons-react";
import { memo } from "react";
import { Alert, Button, Card, Col, Row, Form } from "react-bootstrap";

const StepFinalPrompt = memo(
  ({
    generatePromptPreview,
    copyPrompt,
    exportPrompt,
    getValues,
    AREA_ACTIVITY_OPTIONS,
    uploadedImages,
    isEditing,
  }) => {
    return (
      <div>
        {/* <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <IconFileText className="me-2 text-primary" size={24} />
            <h4 className="mb-0">Prompt Final Gerado</h4>
          </div>
          <div>
            <Button
              variant="outline-secondary"
              size="sm"
              className="me-2"
              onClick={copyPrompt}
            >
              <IconCopy className="me-1" size={16} />
              Copiar
            </Button>
            <Button variant="outline-primary" size="sm" onClick={exportPrompt}>
              <IconDownload className="me-1" size={16} />
              Exportar
            </Button>
          </div>
        </div> */}

        <Alert variant="success" className="mb-4">
          <h6>
            🎉 {isEditing ? "Agente atualizado!" : "Seu agente está pronto!"}
          </h6>
         
        </Alert>

     {/*    <Card className="mb-4">
          <Card.Header className="bg-light">
            <h6 className="mb-0">Preview do Prompt Completo</h6>
          </Card.Header>
          <Card.Body>
            <pre
              className="bg-light p-3 rounded"
              style={{
                whiteSpace: "pre-wrap",
                fontSize: "13px",
                maxHeight: "400px",
                overflow: "auto",
              }}
            >
            </pre>
          </Card.Body>
        </Card> */}

        {/* <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Título do Agente (Sugestão)</Form.Label>
              <Form.Control
                value={`${getValues("agentName")} - ${
                  AREA_ACTIVITY_OPTIONS.find(
                    (opt) => opt.value === getValues("agentArea")
                  )?.label || getValues("agentArea")
                }`}
                readOnly
                className="bg-light"
              />
            </Form.Group>
          </Col>
          
        </Row> */}
      </div>
    );
  }
);

StepFinalPrompt.displayName = "StepFinalPrompt";

export default StepFinalPrompt;
